export default {
  data () {
    return {
      showMore: false,
      visiblePapers: false,
      text: '',
      loading: false,
      hasMore: true
    }
  },
  props: {
    item: Object,
    editing: Boolean,
    index: Number,
    isMobile: Boolean,
    sortType: String
  },
  methods: {
    defaultSortType () {
      if (this.sortType === 'weight:desc') {
        this.text = '重要程度降序'
      } else if (this.sortType === 'time:asc') {
        this.text = '获得时间升序'
      } else if (this.sortType === 'time:desc') {
        this.text = '获得时间降序'
      }
    },
    handleCommand (command) {
      if (command === 'sortModule') {
        this.$emit('sortModules')
      } else if (command === 'hideModule') {
        this.$emit('hideModule', this.index)
      }
    },
    handleSortCommand (command) {
      switch (command) {
        case 'timeAsc':
          this.text = '获得时间升序'
          this.getMoreItem(() => {
            this.$emit('quickSort', 'papers', 'paper', 'jurnal_puttime', 'time:asc', (data) => new Date(data).valueOf())
          })
          break
        case 'timeDesc':
          this.text = '获得时间降序'
          this.getMoreItem(() => {
            this.$emit('quickSort', 'papers', 'paper', 'jurnal_puttime', 'time:desc', (data) => new Date(data).valueOf())
          })
          break
        case 'weightDesc':
          this.text = '重要程度降序'
          this.getMoreItem(() => {
            this.$emit('quickSort', 'papers', 'paper', 'weight', 'weight:desc', (data) => parseInt(data))
          })
          break
      }
    },
    linkTo (type) {
      this.$emit('linkTo', type)
    },
    /********
     * 加载更多内容
     * 若果列表数目大于10条直接显示隐藏，若果小于或等于10条且判断有数据则获取列表
     ***/
    showMoreItem () {
      this.getMoreItem(() => {
        this.showMore = true
        !this.hasMore && (this.$emit('showMsg', `${this.item.name_cn}没有更多成果`))
      })
      if (this.item.data.length > 10) {
        this.showMore = true
      }
    },
    hideMoreItem () {
      this.showMore = false
    },
    /**
     * [moreItem description]
     * @param  {[number]} index [模块的下标]
     * @param  {[function]} callback  回调处理加载效果
     */
    getMoreItem (callback) {
      if (this.hasMore && this.item.data.length <= 10) {
        this.loading = true
        this.$emit('moreItem', this.index, (hasMore) => {
          this.loading = false
          this.hasMore = hasMore
          typeof callback === 'function' && (callback())
        })
      } else {
        typeof callback === 'function' && (callback())
      }
    },
    /**
     * [updateItem description]
     * @param  {[number]} index [模块的下标]
     * @param  {[number]} sub  [单个文件的下标]
     * @param  {[Boolean]} bool [隐藏 or 显示 (显示为1，隐藏为0)]
     * @return null
     */
    updateItem (index, sub, bool) {
      this.$emit('updateItem', index, sub, bool)
    }
  },
  created () {
    this.defaultSortType()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Index/docsMixins.js